module.exports = __webpack_public_path__ + "img/progress_066.21f320a6.png";